// @context TGW-2926 Mac の日本語入力で全角「５００」と打つと、変換して半角にする前に
//   金額欄が 0 に書き換わり、500円のチケットしか作れなかった。打っている間は文字をそのまま残し、
//   欄を離れた時にこの関数で判定する。
import {
  normalizePriceInput,
  parsePriceInput,
  validatePriceInput,
} from './plan_price';

describe('normalizePriceInput（全角・カンマ・空白をそろえる）', () => {
  it('全角数字を半角にする', () => {
    expect(normalizePriceInput('１５００')).toBe('1500');
  });

  it('半角・全角のカンマと前後の空白を取り除く', () => {
    expect(normalizePriceInput(' 1,500 ')).toBe('1500');
    expect(normalizePriceInput('１，５００　')).toBe('1500');
  });

  it('null・undefined は空文字にする', () => {
    expect(normalizePriceInput(null)).toBe('');
    expect(normalizePriceInput(undefined)).toBe('');
  });

  it('数値が渡されても文字列として扱う', () => {
    expect(normalizePriceInput(500)).toBe('500');
  });
});

describe('parsePriceInput（金額として読めるか）', () => {
  it('半角数字はそのまま数値にする', () => {
    expect(parsePriceInput('2000')).toBe(2000);
  });

  it('全角数字も数値として読む（全角で打って半角に変換する前でも弾かない）', () => {
    expect(parsePriceInput('５００')).toBe(500);
  });

  it('カンマ付きも読む', () => {
    expect(parsePriceInput('1,000')).toBe(1000);
  });

  it('空欄は null（0 として扱わない）', () => {
    expect(parsePriceInput('')).toBeNull();
    expect(parsePriceInput('   ')).toBeNull();
  });

  it.each(['abc', '1000円', '-500', '10.5', 'ごひゃく', '5 00a'])(
    '数字以外を含む「%s」は null',
    (text) => {
      expect(parsePriceInput(text)).toBeNull();
    },
  );
});

describe('validatePriceInput（欄を離れた時の判定）', () => {
  const MIN = 500;

  it('500 ちょうどは通す（境界）', () => {
    expect(validatePriceInput('500', MIN)).toEqual({ ok: true, price: 500 });
  });

  it('全角の５００も通す', () => {
    expect(validatePriceInput('５００', MIN)).toEqual({ ok: true, price: 500 });
  });

  it('499 は下限のエラー（境界）', () => {
    expect(validatePriceInput('499', MIN)).toEqual({
      ok: false,
      error: '500円以上で入力してください',
    });
  });

  it('0 は下限のエラー', () => {
    expect(validatePriceInput('0', MIN).ok).toBe(false);
  });

  it('空欄は数字のエラー', () => {
    expect(validatePriceInput('', MIN)).toEqual({
      ok: false,
      error: '金額は数字で入力してください',
    });
  });

  it('数字以外は数字のエラー', () => {
    expect(validatePriceInput('abc', MIN)).toEqual({
      ok: false,
      error: '金額は数字で入力してください',
    });
  });
});
